import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC } from "react";
import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export const CancelRerunModal: FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isPending = false
}) => (
  <Modal
    opened={open}
    onClose={onClose}
    panelClassName="p-6 max-w-[400px] w-full space-y-4"
  >
    <div className="rounded-full bg-danger-50 p-4 mx-auto size-16 flex items-center justify-center">
      <HugeiconsIcon
        icon={AlertCircleIcon}
        size={32}
        className="text-danger-500"
      />
    </div>

    <div className="space-y-2">
      <h1 className="text-xl font-bold text-center">Cancel income re-run</h1>
      <p className="text-center text-content-500 text-base">
        You&apos;re about to cancel the income re-run. Boom will send a
        notification to the applicant that the re-verification request was
        canceled. You won&apos;t be charged for incomplete report.
      </p>
    </div>

    <div className="flex gap-2 w-full">
      <Button
        size={ButtonSize.BASE}
        variant={ButtonVariant.BASE}
        className="w-full"
        onClick={onClose}
        disabled={isPending}
      >
        Close
      </Button>
      <Button
        size={ButtonSize.BASE}
        variant={ButtonVariant.DANGER}
        className="w-full"
        loading={isPending}
        disabled={isPending}
        onClick={onConfirm}
      >
        Cancel re-run
      </Button>
    </div>
  </Modal>
);
